import { createContext, useContext } from 'react';

// Measured height (px) of the sticky app header (navbar + emulation banner +
// sub-nav). Anything that sticks below the header uses this — in CSS as
// var(--app-header-h), in JS via useAppHeaderHeight().
export const HeaderHeightContext = createContext(48);

export const useAppHeaderHeight = () => useContext(HeaderHeightContext);

// The job shown on the job page ({ jobNo, isOverhead } once its header loads), so
// the app header can leave the billing tabs off an overhead job.
export const CurrentJobContext = createContext({ job: null, setJob: () => {} });
export const useCurrentJob = () => useContext(CurrentJobContext);
